
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.99271 4.33599C2.06501 4.33599 1.31387 5.09977 1.31387 6.04309V7.749H18.6861V6.04309C18.6861 5.09977 17.935 4.33599 17.0074 4.33599H2.99271ZM20 6.04309C20 4.36192 18.6606 3 17.0074 3H2.99271C1.33938 3 0 4.36192 0 6.04309V13.9569C0 15.6381 1.33938 17 2.99271 17H17.0074C18.6606 17 20 15.6381 20 13.9569V6.04309ZM18.6861 9.08499H1.31387V13.9569C1.31387 14.9002 2.06501 15.664 2.99271 15.664H17.0074C17.935 15.664 18.6861 14.9002 18.6861 13.9569V9.08499ZM3.14862 13.1672C3.14862 12.7982 3.44274 12.4992 3.80556 12.4992H5.32848C5.69129 12.4992 5.98542 12.7982 5.98542 13.1672C5.98542 13.5361 5.69129 13.8352 5.32848 13.8352H3.80556C3.44274 13.8352 3.14862 13.5361 3.14862 13.1672ZM7.7863 13.1672C7.7863 12.7982 8.08041 12.4992 8.44319 12.4992H9.965C10.3278 12.4992 10.6219 12.7982 10.6219 13.1672C10.6219 13.5361 10.3278 13.8352 9.965 13.8352H8.44319C8.08041 13.8352 7.7863 13.5361 7.7863 13.1672Z","fill":"#8338EC"}})])
          )
        }
      }
    